<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Yükleme Tipi</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
              <input type="text" class="form-control" placeholder="Yükleme Tipi" v-model="value.Name"/>
            </v-validator> 
        </div>
    </div>
</template>

<script>
import VValidator from '@/components/VValidator.vue'
export default {
  components: { VValidator },
    props:{
        value:Object,
        errors:Object
    },
}
</script>

<style>

</style>